import { Bot, Building2, CalendarDays, CalendarRange, LayoutDashboard, Network, Radio, UserCheck, UserRound, type LucideIcon } from "lucide-react";

export const workspaceViewIds = [
  "overview",
  "graph",
  "people",
  "companies",
  "events",
  "lists",
  "schedule",
  "signals",
  "current",
  "privateAgent",
  "help",
  "tenant"
] as const;

export type WorkspaceViewId = (typeof workspaceViewIds)[number];

export const privateAgentWorkspaceFacetIds = ["chat", "research"] as const;

export type PrivateAgentWorkspaceFacet = (typeof privateAgentWorkspaceFacetIds)[number];

export function isWorkspaceViewId(value: string): value is WorkspaceViewId {
  return (workspaceViewIds as readonly string[]).includes(value);
}

export function isPrivateAgentWorkspaceFacet(value: string): value is PrivateAgentWorkspaceFacet {
  return (privateAgentWorkspaceFacetIds as readonly string[]).includes(value);
}

export type WorkspaceNavItem = {
  icon: LucideIcon;
  id: WorkspaceViewId;
};

export function initialWorkspaceView(hasStoredSession: boolean) {
  return hasStoredSession ? "overview" : "graph";
}

// Shared workspace view navigation. Rendered as the horizontal header tabs.
// Help is intentionally excluded here — it lives in the account menu instead.
export const navItems: readonly WorkspaceNavItem[] = [
  { icon: LayoutDashboard, id: "overview" },
  { icon: Network, id: "graph" },
  { icon: UserRound, id: "people" },
  { icon: Building2, id: "companies" },
  { icon: CalendarDays, id: "events" },
  { icon: CalendarRange, id: "schedule" },
  { icon: Radio, id: "signals" },
  { icon: UserCheck, id: "current" },
  { icon: Bot, id: "privateAgent" }
];
